"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var PortalIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M5,5 L19,5 C19.5522847,5 20,5.44771525 20,6 L20,18 C20,18.5522847 19.5522847,19 19,19 L5,19 C4.44771525,19 4,18.5522847 4,18 L4,6 C4,5.44771525 4.44771525,5 5,5 Z M10,8 L10,14.2807018 L12,14.2807018 L12.6842105,15.7192982 C12.754386,15.8947368 12.9122807,16 13.0877193,16 C13.1403509,16 13.1929825,15.9824561 13.245614,15.9649123 C13.4736842,15.877193 13.5789474,15.6140351 13.4912281,15.3859649 L13.245614,13.692627 L14.5263158,12.5263158 L10,8 Z M5.5,6.5 L5.5,17.5 L18.5,17.5 L18.5,6.5 L5.5,6.5 Z" }))); };
exports.PortalIcon = PortalIcon;
